import { render, staticRenderFns } from "./BIEmitterSummarySection.vue?vue&type=template&id=efc08250"
import script from "./BIEmitterSummarySection.vue?vue&type=script&lang=js"
export * from "./BIEmitterSummarySection.vue?vue&type=script&lang=js"
import style0 from "./BIEmitterSummarySection.vue?vue&type=style&index=0&id=efc08250&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports